import { Dictionary } from 'lodash';
import { ChartSeriesV2, DataRange, SeriesValue } from 'src/components/ui/chart/types';
import { TimeSeries, TagMeaning, NumericDataPoint } from 'src/models';
import { parseBitfield } from './helpers';
import { differenceInMilliseconds } from 'date-fns';

export const parseBitfieldPoint = (point: ChartSeriesV2): ChartSeriesV2[] => {
  const arrMeanings = point.meanings?.map(({ value }) => {
    return {
      ...point,
      values: point.values.map((point) => {
        const values = parseBitfield(point.y);
        return {
          x: point.x,
          y: values.reduce((acc, curr, index) => {
            return curr === '1' && Number(value) === index ? index : acc;
          }, -1),
        };
      }),
    };
  });
  return arrMeanings;
};

export const parseBitfieldBeforeStartRangePoint = (
  meanings: TagMeaning[],
  firstPoint: NumericDataPoint
): SeriesValue[] => {
  const arrMeanings = meanings.map(({ value }) => {
    const bitfieldValues = parseBitfield(firstPoint.value || 0);
    return {
      x: firstPoint.time,
      y: bitfieldValues.reduce((acc, curr, index) => {
        return curr === '1' && Number(value) === index ? index : acc;
      }, -1),
    };
  });

  return arrMeanings || [];
};

export const getBeforeStartRangePoint = (
  point: ChartSeriesV2,
  fullRangeSnapshots: Dictionary<TimeSeries>,
  ranges: DataRange[],
  isBitfield: boolean
): SeriesValue | SeriesValue[] | undefined => {
  if (
    !fullRangeSnapshots[point.key] ||
    !fullRangeSnapshots[point.key].points ||
    fullRangeSnapshots[point.key].points.length === 0
  ) {
    return undefined;
  }

  const closestPoint = fullRangeSnapshots[point.key].points.reduce((prev, curr) => {
    const currDiff = differenceInMilliseconds(curr.time, ranges[0].xMin);
    if (currDiff > 0) return prev;

    const prevDiff = differenceInMilliseconds(prev.time, ranges[0].xMin);
    return Math.abs(currDiff) < Math.abs(prevDiff) ? curr : prev;
  });

  if (isBitfield) {
    return parseBitfieldBeforeStartRangePoint(point.meanings, closestPoint);
  }

  return {
    x: closestPoint.time,
    y: closestPoint.value || 0,
  };
};
